// src/components/StoreLocator.js
import React, { useState } from "react";
import "./StoreLocator.css";
import prime from "./prime.jpg";

const locations = [
  {
    id: "clinic1",
    label: "01",
    type: "PrimeMax Dental Clinic",
    name: "PrimeMax Dental Clinic",
    address: "Near Central Bank Of India, Zoo Road Tiniali, Zoo Tiniali, Guwahati, Assam 781003",
    img: prime,
  },
  // {
  //   id: "clinic2",
  //   label: "02",
  //   type: "BRANCH CLINIC",
  //   name: "Dentoshine – North Point",
  //   address: "27, North Point Avenue, Guwahati, Assam 781003",
  //   img: prime,
  // },
];

export default function StoreLocator() {
  const [activeId, setActiveId] = useState(null);

  return (
    <section className="locator-section">
      <h2 className="locator-heading">Our Location</h2>
      {/* <p className="locator-subtitle">
        Hover over a location to preview the clinic.
      </p> */}

      <div className="locator-list">
        {locations.map((loc) => (
          <button
            key={loc.id}
            className={`locator-item ${
              activeId === loc.id ? "active" : ""
            }`}
            onMouseEnter={() => setActiveId(loc.id)}
            onMouseLeave={() => setActiveId(null)}
            onFocus={() => setActiveId(loc.id)}
            onBlur={() => setActiveId(null)}
          >
            {/* full-row background image */}
            <div className="locator-bg">
              <img src={loc.img} alt={loc.name} />
            </div>

            {/* text content on top */}
            <div className="locator-content-row">
              <div className="locator-label">{loc.label}</div>
              <div className="locator-text">
                <div className="locator-type">{loc.type}</div>
                <div className="locator-address">{loc.address}</div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
